import { APIGATEWAY_BASE_URL } from 'src/dataLayer/env'

import makeAjaxRequest from '../makeAjaxRequest'
import { formatCaptchaResult } from './helpers.js'

const ERROR_KEYS = {
  400: {
    key: 'common.error.unknown',
  },
  422: {
    restricted_account: {
      key: 'email.error.restricted_account',
    },
  },
  default: {
    key: 'password.error.invalid_credentials',
  },
}

const getPayload = ({ captchaResponseToken, email, password, sessionCode }) => {
  const payload = {
    token: {
      email,
      password,
      session: {
        captcha: formatCaptchaResult(captchaResponseToken),
        code: sessionCode,
      },
    },
  }

  return payload
}

export default (properties) =>
  makeAjaxRequest({
    errorKeys: ERROR_KEYS,
    payload: getPayload(properties),
    url: `${APIGATEWAY_BASE_URL}/v1.0.0/${properties.locale}/authentication/token`,
    verb: 'POST',
  }).then((response) => response.token.value)

export { ERROR_KEYS }
